var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.zoneMap)?_c('ZoneInput',{attrs:{"zone-map":_vm.zoneMap,"value":null,"palette":_vm.zoneMapPalette}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }